import { combineReducers } from 'redux-merge-immutable-reducers';

import customer from './customer/customer';
import hotels from './hotels/hotels';
import avail from './avail/avail';
import availServices from './avail/availServices';
import availCalendar from './avail/availCalendar';
import availCache from '@synergycms_core/store/avail/availCache';
import notifications from '@synergycms_core/store/notifications/notifications';
import app from '@synergycms_core/store/app/app';
import translations from '@synergycms_core/store/translations/translations';
import actions from './actions';
import { List, fromJS, Map } from 'immutable';
import { handleActions } from 'redux-actions';
import system from '@synergycms_core/store/customer/system';
//REDUCERS

const countries = handleActions(
  {
    [actions.countries.get.toString()]: (store, action) => {
      return fromJS(action.payload);
    }
  },
  List()
);


const group = handleActions(
  {
    [actions.group.get.toString()]: (store, action) => {
      return fromJS(action.payload);
    }
  },
  List()
);

const groupInfo = handleActions(
  {
    [actions.groupInfo.getAsync.toString()]: (store, action) => {
      return fromJS(action.payload);
    }
  },
  Map()
);

const availQuery = handleActions(
  {
    [actions.availQuery.setMultiAvailKeys.toString()]: (store, action) => {
       return store.set("multi", action.payload);
    },
    [actions.availQuery.setMonoAvailKeys.toString()]: (store, action) => {
      return store.set("mono", action.payload);
   }
  },
  Map({
    multi : Map({
      base_query_params :"base_query_params",
      params:"params",
      query_params :"query_params",
      service_params :"service_params",
      service_query_params :"service_query_params",
      calendar_params :"calendar_params",
      calendar_query_params : "calendar_query_params",
      base_calendar_params :"base_calendar_params",
      base_calendar_query_params :"base_calendar_query_params",
    }),
    mono: Map({
      base_query_params :"base_query_params",
      params:"params",
      query_params :"query_params",
      service_params :"service_params",
      service_query_params :"service_query_params",
      calendar_params :"calendar_params",
      calendar_query_params :"calendar_query_params",
      base_calendar_params :"base_calendar_params",
      base_calendar_query_params :"base_calendar_query_params",
    })
  })
);


export default combineReducers({ customer, app,translations, hotels, avail, availServices, availCalendar, availCache, countries, group, groupInfo, system, notifications,availQuery });
